angular.module("app").factory("pagination", [ function () {

    var pagination = {
        page: 1,
        changePage: angular.noop,
        totalItems: 0,
        limit: 10,
        maxSize: 5
    };
    return {
        init: function (changePage, totalItems) {
            var temp = angular.copy(pagination);
            if (!!changePage) {
                temp.changePage = changePage
            }
            if (!!totalItems) {
                temp.totalItems = totalItems
            }
            return temp
        }
    }
}]);